
function apiSync() {
  return new Promise((resolve, reject) => {
    const shopifyId = window.customerId;
    //const apiUrl = `https://skechers.techzonite.com/api/skechers/syncSG?shopifyID=${shopifyId}`;
    const apiUrl = `https://techzonite.skechers.com.my/api/skechers/syncSG?shopifyID=${shopifyId}`;
    const iframe = document.createElement("iframe");
    iframe.style.display = "none";
    iframe.src = apiUrl;
    document.body.appendChild(iframe);

    // fetch(apiUrl, {
    //   method: 'OPTIONS',
    //   headers: {
    //     'Content-Type': 'application/json',
    //   },
    // })
    //   .then((response) => {
    //     if (response.ok) {
    //       resolve();
    //     } else {
    //       reject();
    //     }
    //   })
    //   .catch((error) => {
    //     reject(error);
    //   });
  });
}


document.addEventListener("DOMContentLoaded", function() {
  if (window.customerId !== undefined) {

    const lastSyncDate = localStorage.getItem("lastSync");
    const currentDate = new Date();
    
    if (!lastSyncDate || new Date(lastSyncDate) < currentDate) {
      apiSync()
        .then(() => {
          const nextSyncDate = new Date();
          nextSyncDate.setDate(nextSyncDate.getDate() + 1); 
          localStorage.setItem("lastSync", nextSyncDate.toISOString());
          console.log('Synchronization success.');
        })
        .catch(() => {
          const nextSyncDate = new Date();
          nextSyncDate.setSeconds(nextSyncDate.getSeconds() + 5);
          localStorage.setItem("lastSync", nextSyncDate.toISOString());
          console.error('Synchronization failed.');
        });
    }
  } else {
    //console.log('Customer ID is not available.');
  }
});

